export default "__VITE_ASSET__DeEy2nLr__"